import PropTypes from 'prop-types';

import { BannerStatus } from 'ui-components/components/banner-message/banner-enums';
import { BannerMessageV2 } from 'ui-components/components/banner-message/banner-message-v2';

import PhoneVerificationRequiredMessage from './formatted-message';

const PhoneVerificationBanner = ({ sellerLabelProviderId }) => {
  return (
    <BannerMessageV2
      content={<PhoneVerificationRequiredMessage sellerProviderId={sellerLabelProviderId} useSmallerFontSize={false} />}
      status={BannerStatus.Error}
    />
  );
};

PhoneVerificationBanner.propTypes = {
  sellerLabelProviderId: PropTypes.string.isRequired,
};

export default PhoneVerificationBanner;
